import UnitActions from './actions'
import request from './../../utils/requestConfig'
import AdoptionActions from '../adoption/actions'
import { addNotification as notify } from 'reapop'
import {paramsWarningNotify} from '../../utils/notifyConfig'

export default class UnitMiddleware {
  static fetchUnit () {
    return (dispatch) => {
      dispatch(UnitActions.fetchUnitRequest())
      request.get('/units/particules')
        .then(({ data }) => {
          dispatch(UnitActions.fetchUnitSuccess({ data }))
        })
        .catch((error) => {
          dispatch(UnitActions.fetchUnitError(error))
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar',
            status: error.response.status
          }))
        })
    }
  }
  static fetchSchool () {
    return (dispatch, getState) => {
      const { paginate } = getState().units.school
      const { page, perPage } = paginate
      dispatch(UnitActions.fetchSchoolRequest())
      request.get('/units/adoptants_created_by_user', {
        params: {
          per: perPage,
          page: page || 1
        }
      })
        .then(({ data, headers }) => {
          dispatch(UnitActions.fetchSchoolSuccess({ data, totalCount: headers['x-total-count'] }))
        })
        .catch((error) => {
          dispatch(UnitActions.fetchSchoolError(error))
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar',
            status: error.response.status
          }))
        }
        )
    }
  }
  static changeUnitSelect (unit) {
    return (dispatch) => {
      dispatch(UnitActions.changeUnitSuccess(unit))
      dispatch(AdoptionActions.triggerFetchAdoptionsToBeSent())
      dispatch(UnitMiddleware.getUnit())
    }
  }
  static getUnit () {
    return (dispatch, getState) => {
      const { currentItem } = getState().units
      dispatch(UnitActions.getUnitRequest())
      if (currentItem.item !== null) {
        request.get(`/units/${currentItem.item.value}`)
          .then(({ data }) => {
            dispatch(UnitActions.getUnitSuccess(data))
          })
          .catch((error) => {
            dispatch(UnitActions.getUnitError(error))
            dispatch(notify({
              ...paramsWarningNotify,
              message: 'Não foi possível carregar',
              status: error.response.status
            }))
          })
      }
    }
  }
  static changeSchoolActivePage (page) {
    return (dispatch) => {
      dispatch(UnitActions.changeSchoolActivePage(page))
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/unit/middleware.js